import React, { Component } from "react";
import { Row, Col, Grid } from "react-bootstrap";

import { Helmet } from "react-helmet";

import Sidebar from "../../Sidebar/Sidebar";
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";
import ContactMap from "./ContactMap";
import BannerRectangleLarge from "../../Banner/BannerRectangleLarge";

import { translate, getLanguage } from "../../Translation/Translation";

import Recaptcha from "react-recaptcha";
import { Message, Button, Checkbox, Form, Icon } from "semantic-ui-react";
import { FETCH_URL } from "../../../utilities";
import Modal from "../../Modal/Modal";
import InnerModalGDPR from "../../InnerModal/InnerModalGDPR";

class Contact extends Component {

  constructor(props) {
    super(props);
    this.state = {
        startDate: null,
        endDate: null,
        disabled: true,
        isLoading: false,
        completed: false,
        showModal: false,
        checkbox1: false,
        checkbox2: false,
        checkbox3: false,
        checkbox4: false,
    }
    this.handleChange = this.handleChange.bind(this);
    this.handleModalClick = this.handleModalClick.bind(this);
    
  }


  handleModalClick(event) {
    event.preventDefault();
    this.setState({ 
      showModal: !this.state.showModal,
      checkbox1: false,
      checkbox2: false,
      checkbox3: false,
      checkbox4: false, });
  }

  componentDidMount(){
    window.scrollTo(0, 0)
  }

  showGDPRModal = () => {


    this.setState({ isLoading: true, showModal: true })
  }

  reportCheckboxChanged = (checkboxName) => {
    console.log(this.state);
    this.setState({
      [checkboxName]: !this.state[checkboxName]
    })
  }

  submitForm = () => {
    
    this.setState({ isLoading: true, showModal: false })

    return fetch(`${FETCH_URL}/contactMail.php?company=${this.state.company}&firstName=${this.state.firstName}&lastName=${this.state.lastName}&region=${this.state.region}&phoneNumber=${this.state.phoneNumber}&email=${this.state.email}&yourComment=${this.state.yourComment}&checkbox1=${this.state.checkbox1}&checkbox2=${this.state.checkbox2}&checkbox3=${this.state.checkbox3}&checkbox4=${this.state.checkbox4}`, {
        method: 'GET',
    })
        .then((response) => {
            this.setState({ isLoading: false, completed: true, disabled: true, showModal: false })
        }).catch((error) => {
            console.error(error);
        })
  }

 
  callback = () => {
     // console.log('Done!!!!');
  };

  // specifying verify callback function
  verifyCallback = (response) => {
    this.setState({ disabled: false })
  };

  handleChange(event) {
      if (event.target.name === "morning" || event.target.name === "afternoon") {
          this.setState({ [event.target.name]: event.target.checked })
      } else {
          this.setState({ [event.target.name]: event.target.value })
      }

      const {email, yourComment} = this.state;
      
      if(email && email !="" && yourComment && yourComment != ""){
        this.setState({ disabled: false })
      }
      
  }

  render() {
   
    return (
      <div>
        <Grid fluid className="no-padding">
          <Helmet>
            <title>Contact Us | Openseas</title>
            <meta
              name="description"
              content="H Openseas σας ενημερώνει για όλα τα δρομολόγια πλοίων, πληροφορίες εταιρειών και γραφείων, κρατήσεις εισιτηρίων, πλοίων/ξενοδοχείων. Επικοινωνήστε μαζί μας!"
            />
          </Helmet>
          <Row style={{ margin: "0px" }}>
            <Col style={{ margin: "0px" }}>
              <Header data={this.props} />
            </Col>
          </Row>
          <Modal open={this.state.showModal} clickOutSide={this.handleModalClick}>
            <InnerModalGDPR
              clickHandler={this.handleModalClick}
              submitForm= {this.submitForm}
              reportCheckboxChanged= {this.reportCheckboxChanged}
              checkbox1= {this.state.checkbox1}
              checkbox2= {this.state.checkbox2}
              checkbox3= {this.state.checkbox3}
              checkbox4= {this.state.checkbox4}
            />
          </Modal>
          <Row>
            <div className="OSPageContainer" style={{ justifyContent: "center"}}>
              <div className="OSPageContent">
                <h1
                  style={{
                    fontSize: 28,
                    fontWeight: "normal",
                    paddingTop: 20,
                    color: "rgb(41,63,84)"
                  }}
                >
                  {translate(
                    getLanguage(),
                    "The Best Ferry Guide for Greece..."
                  )}
                </h1>
                <h3
                  style={{
                    fontSize: 24,
                    fontWeight: "normal",
                    paddingTop: 20,
                    color: "rgb(41,63,84)"
                  }}
                >
                  {translate(
                    getLanguage(),
                    "The most reliable guide for your trips in Greek Islands. All ferry routes, info for ferry companies and travel agencies, booking services for ferries and hotels. The most valid info by LIKNOSS systems and the Greek ferry industry."
                  )}
                </h3>
              </div>
            </div>
          </Row>
          <Row>
            <div className="OSPageContainer" style={{ justifyContent: "center"}}>
              <div className="OSPageContent">
                <Form>
                  <div className="contactLabel" style={{ margin: "0px" }}>
                    {translate(getLanguage(), "Contact Form")}
                  </div>
                  {/* <Form.Field required>
                    <Form.Input
                      required
                      name="company"
                      label={translate(getLanguage(), "Company name")}
                      onChange={this.handleChange}
                      placeholder={translate(getLanguage(), "Company name")}
                    />
                  </Form.Field>
                  <Form.Group widths="equal">
                    <Form.Input
                      required
                      name="firstName"
                      label={translate(getLanguage(), "First name")}
                      onChange={this.handleChange}
                      placeholder={translate(getLanguage(), "First name")}
                    />
                    <Form.Input
                      required
                      name="lastName"
                      label={translate(getLanguage(), "Last name")}
                      onChange={this.handleChange}
                      placeholder={translate(getLanguage(), "Last name")}
                    />
                  </Form.Group>
                  <Form.Group widths="equal">
                    <Form.Input
                      required
                      name="region"
                      label={translate(getLanguage(), "Region")}
                      onChange={this.handleChange}
                      placeholder={translate(getLanguage(), "Region")}
                    />
                    <Form.Input
                      required
                      name="phoneNumber"
                      label={translate(getLanguage(), "Phone number")}
                      onChange={this.handleChange}
                      placeholder={translate(getLanguage(), "Phone number")}
                    />
                  </Form.Group> */}
                  <Form.Input
                    required
                    name="email"
                    label={translate(getLanguage(), "Email")}
                    onChange={this.handleChange}
                    placeholder={translate(getLanguage(), "Email")}
                  />
                  <Form.TextArea
                    name="yourComment"
                    label={translate(getLanguage(), "Your comment")}
                    onChange={this.handleChange}
                    placeholder={`${translate(getLanguage(), "Your comment")}...`}
                  />
                </Form>
                <Recaptcha
                  sitekey="6Lf0Zh8UAAAAALFj5VbOILRHcTQXl5yeAj5XzThO"
                  render="explicit"
                  verifyCallback={this.verifyCallback}
                  onloadCallback={this.callback}
                />
                <Button icon labelPosition='right' style={{ marginTop: "10px" }} disabled={this.state.disabled} type="submit" onClick={() => this.showGDPRModal()}>
                  {translate(getLanguage(), "Submit")}
                  <Icon name='right arrow' style={{ padding: "0px" }} />
                </Button>
              </div>
            </div>
          </Row>
          {/* <Row style={{ margin: "0px" }}> */}
            {/* <div className="OSPageContainer" style={{ justifyContent: "center"}}>
              <div className="OSPageContent" style={{ width: "100%" }}>
                <div className="contactUsInfo">
                  <h3>{translate(getLanguage(), "FORTHcrs S.A.")}</h3>
                  <br />
                  {translate(getLanguage(), "Atthidon 4,176 71 Kallithea")}
                  <br />
                  {translate(getLanguage(), "Tel.: +30 211 95.58.800")}
                  <br />
                  {translate(getLanguage(), "Fax: +30 211 95.59.909")}
                  <br />
                  {translate(getLanguage(), "Email: info@openseas.gr")}
                  <br />
                </div>
              </div>
            </div> */}
            <Row style={{ margin: "40px 0px 0px 0px", height: "300px" }}>
              <ContactMap
                stop={{ lat: 38.009190, lng: 23.806594 }}
                googleMapURL="https://maps.googleapis.com/maps/api/js?v=3.exp&key=AIzaSyDF9MTsdQEmSiTZxeyxN_0kXFW0OMEIu-I&language=en&libraries=geometry"
                loadingElement={<div style={{ height: `200px` }} />}
                containerElement={
                  <div style={{ height: `100%`, width: `100%` }} />
                }
                mapElement={
                  <div
                    style={{
                      height: "100%",
                      width: "100%",
                      marginBottom: "140px"
                    }}
                  />
                }
              />
            </Row>
        

          {/* </Row> */}
          <Row style={{ margin: "0px" }}>
            <Footer />
          </Row>
        </Grid>
      </div>
    );
  }
}
export default Contact;



// WEBPACK FOOTER //
// ./src/components/Pages/Contact/Contact.js